import { manufacturer } from '@/modules/standardItems/schemas/baseFilters'

export default [
  manufacturer()
]
